export default "__VITE_ASSET__DDxU826G__"